import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
} from "@mui/material";
import moment from "jalali-moment";
import { smsCampaignAvailableHours } from "../constants/SmsCampaignContants";

export default function SmsCampaignTimePicker(props: {
    onChange: (date: string | null) => void;
    initialValue?: string;
    label?: string;
}) {
    const onHourChange = (value: SelectChangeEvent<number>) => {
        props.onChange(
            moment(props.initialValue)
                .startOf("D")
                .add(value.target.value, "hours")
                .toJSON()
        );
    };

    const hour = moment(props.initialValue).hours();

    return (
        <Box sx={{ width: "100%" }}>
            <FormControl fullWidth>
                <InputLabel>ساعت ارسال</InputLabel>

                <Select
                    label="تاریخ ارسال"
                    value={hour}
                    onChange={onHourChange}
                >
                    {smsCampaignAvailableHours.map((i) => {
                        return (
                            <MenuItem
                                key={i.hour + i.addition}
                                value={i.hour + i.addition}
                            >
                                {i.hour + " " + i.timeOfDateLabel}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </Box>
    );
}
